import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../baseQueryWithReauth';
import type { TranscribeRequest, TranscribeResponse } from './models';

/**
 * Speech for every role: dictation into any input (POST /transcriptions —
 * our speech container behind it).
 */
export const speechApi = createApi({
  reducerPath: 'speech',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    transcribeAudio: build.mutation<TranscribeResponse, TranscribeRequest>({
      query: ({ audio, extension }) => {
        const body = new FormData();
        body.append('audio', audio, `dictation.${extension}`);

        return {
          url: '/transcriptions',
          method: 'POST',
          body,
          headers: { Accept: 'application/json' },
        };
      },
    }),
  }),
});

export const { useTranscribeAudioMutation } = speechApi;
